// extracted by mini-css-extract-plugin
export default {"logo":"Sidebar_logo__y2L+D","image":"Sidebar_image__TdA3A","sidebar":"Sidebar_sidebar__AUZ80"};